import type {
  UserGetCitiesRequest,
  UserGetCountiesRequest,
  UserGetDistrictsRequest,
  AdminDeleteLocationParams,
  AdminSetLocationInput,
} from '../api'
import { api } from '../api'

const getProvinces = async () => {
  return await api.v1.userGetProvinces({
    headers: {
      authorization: null,
    },
  })
}

const getCounties = async (data: UserGetCountiesRequest) => {
  if (typeof data.provinceID !== 'number') {
    throw new Error('Province ID is required')
  }
  return await api.v1.userGetCounties(
    { provinceId: data.provinceID },
    {
      headers: {
        authorization: null,
      },
    },
  )
}

const getCities = async (data: UserGetCitiesRequest) => {
  if (typeof data.countyID !== 'number') {
    throw new Error('County ID is required')
  }
  if (typeof data.provinceID !== 'number') {
    throw new Error('Province ID is required')
  }
  return await api.v1.userGetCities(
    { countyId: data.countyID, provinceId: data.provinceID },
    {
      headers: {
        authorization: null,
      },
    },
  )
}

const getDistricts = async (data: UserGetDistrictsRequest) => {
  if (typeof data.countyID !== 'number') {
    throw new Error('County ID is required')
  }
  if (typeof data.provinceID !== 'number') {
    throw new Error('Province ID is required')
  }
  return await api.v1.userGetDistricts(
    { countyId: data.countyID, provinceId: data.provinceID },
    {
      headers: {
        authorization: null,
      },
    },
  )
}

const adminSaveLocation = async (data: AdminSetLocationInput) => {
  return await api.v1.adminSaveLocation(data)
}

const adminDeleteLocation = async (data: AdminDeleteLocationParams) => {
  return await api.v1.adminDeleteLocation(data)
}

export default {
  getProvinces,
  getCounties,
  getCities,
  getDistricts,
  adminSaveLocation,
  adminDeleteLocation,
}
